export default __webpack_public_path__ + "static/media/mld.3763c451.svg";